import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReportForm, ReportSuccess } from '~/components/Report';
import { HelmetHead } from '~/components/common';
import { PAGE_ROUTE } from '~/constants';

type Step = 'Report' | 'ReportSuccess';

export default function Report() {
  const [step, setStep] = useState<Step>('Report');
  const navigate = useNavigate();
  const onClickConfirm = () => {
    navigate(PAGE_ROUTE.MAIN);
  };
  const renderStep = (stepName: Step) => {
    switch (stepName) {
      case 'Report':
        return <ReportForm onNextStep={() => setStep('ReportSuccess')} />;
      case 'ReportSuccess':
        return <ReportSuccess onClickConfirm={onClickConfirm} />;
      default:
        return null;
    }
  };

  return (
    <>
      <HelmetHead title='Report' />
      {renderStep(step)}
    </>
  );
}
